import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { Button } from './Button';
import { IconButton } from './IconButton';
import { GlowButtonProps, isButtonProps } from './buttonProps';

/**
 * GlowButton component
 */
export const GlowButton: ComponentMemo<GlowButtonProps> = memo((props) => {
    if (isButtonProps(props)) {
        return <Button {...props} />;
    }

    return <IconButton {...props} />;
});

GlowButton.displayName = 'GlowButton';
